module.exports = __webpack_public_path__ + "img/privacy-icon.df424dd3.svg";